import Button from '@atlaskit/button/standard-button';
import ShortcutIcon from '@atlaskit/icon/glyph/shortcut';
import { N800 } from '@atlaskit/theme/colors';
import { ANALYTICS_ACTION_CLICKED, ANALYTICS_SUBJECT_IMAGE, ANALYTICS_SUBJECT_IMAGE_LINK, ButtonClickedEvent, EVENT_CONTAINER_APPLISTING_SCREEN, ImageClickedEvent, useAnalyticsEvents } from '@atlassian/mpac-analytics';
import { pluralize } from '@atlassian/mpac-utils';
import React from 'react';
import { TEST_ID } from '../../../../../constants';
import Image from '../../../../Image';
import { BackgroundUnderlay, Caption, Container, Content, H3, ImageContainer, ShortcutIconWrapper } from './Gallery.styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Gallery = props => {
  const fireAnalyticsEvent = useAnalyticsEvents();
  const firstScreenshot = props.screenshots[0];
  const handleImageClick = () => {
    fireAnalyticsEvent({
      eventType: ImageClickedEvent,
      event: ANALYTICS_ACTION_CLICKED,
      eventContainer: EVENT_CONTAINER_APPLISTING_SCREEN,
      attributes: {
        source: EVENT_CONTAINER_APPLISTING_SCREEN,
        objectType: ANALYTICS_SUBJECT_IMAGE,
        section: 'Gallery'
      }
    });
    props.onMediaClick(firstScreenshot);
  };
  const handleButtonClick = () => {
    fireAnalyticsEvent({
      eventType: ButtonClickedEvent,
      event: ANALYTICS_ACTION_CLICKED,
      eventContainer: EVENT_CONTAINER_APPLISTING_SCREEN,
      actionSubjectId: ANALYTICS_SUBJECT_IMAGE_LINK,
      attributes: {
        source: EVENT_CONTAINER_APPLISTING_SCREEN,
        objectType: ANALYTICS_SUBJECT_IMAGE_LINK,
        section: 'Gallery'
      }
    });
    props.onMediaClick(firstScreenshot);
  };
  const icon = /*#__PURE__*/_jsx(ShortcutIconWrapper, {
    children: /*#__PURE__*/_jsx(ShortcutIcon, {
      label: "",
      primaryColor: "var(--ds-icon, ".concat(N800, ")"),
      size: "small"
    })
  });
  return /*#__PURE__*/_jsxs(Container, {
    "data-testid": TEST_ID.GALLERY,
    children: [/*#__PURE__*/_jsx(BackgroundUnderlay, {}), /*#__PURE__*/_jsx(H3, {
      children: "Gallery"
    }), /*#__PURE__*/_jsxs(Content, {
      children: [/*#__PURE__*/_jsx(ImageContainer, {
        children: /*#__PURE__*/_jsx(Image, {
          image: firstScreenshot.image,
          onClick: handleImageClick,
          loading: "lazy"
        })
      }), /*#__PURE__*/_jsxs("div", {
        children: [firstScreenshot.caption && /*#__PURE__*/_jsxs(Caption, {
          children: [" ", firstScreenshot.caption]
        }), /*#__PURE__*/_jsx(Button, {
          appearance: "link",
          onClick: handleButtonClick,
          spacing: "none",
          iconAfter: icon,
          children: pluralize('image', props.screenshots.length + props.highlights.length, true)
        })]
      })]
    })]
  });
};
export default Gallery;